import { render, staticRenderFns } from "./Dishonor.vue?vue&type=template&id=2e85b3db&scoped=true&"
import script from "./Dishonor.vue?vue&type=script&lang=js&"
export * from "./Dishonor.vue?vue&type=script&lang=js&"
import style0 from "./Dishonor.vue?vue&type=style&index=0&id=2e85b3db&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e85b3db",
  null
  
)

export default component.exports